import { render } from "./VideoVue.vue?vue&type=template&id=05890313&scoped=true"
import script from "./VideoVue.vue?vue&type=script&lang=js"
export * from "./VideoVue.vue?vue&type=script&lang=js"

import "./VideoVue.vue?vue&type=style&index=0&id=05890313&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05890313"]])

export default __exports__